<script>
  export default {
    props: {
      google: {
        type: Object,
        required: true
      },
      map: {
        type: Object,
        required: true
      },
      marker: {
        type: Object,
        required: true
      }
    },
    mounted() {

      const { Marker } = this.google.maps;
      let markerAux=new Marker({
        position: this.marker.position,
        marker: this.marker,
        map: this.map,
        draggable:true,
        title: this.marker.title
      });
      // aca registramos el marker de google
      this.$store.dispatch('sGoogleMaps/addNewPosition', markerAux);
      // aca solo registramos la latitud y longitud
      this.$store.dispatch('sGoogleMaps/addNewPositionLocation', this.marker.position);

      const that=this;
      this.google.maps.event.addListener(this.map, 'click', e=>{
        // console.log('se ha anadido el evento escucha')
        that.mCaptaPosicion(e.latLng);
      })
    },
    methods:{
      async mCaptaPosicion(latLng) {        
        console.log('llegando a la funcion desde otro punto')
        console.log(`la posicion es ${latLng}`);
        let auxPosition=String(latLng);
        auxPosition=auxPosition.split(',');
        let latAux=parseFloat(auxPosition[0].replace('(', ''));
        let lngAux=parseFloat(auxPosition[1].replace(')', ''));
        let auxNewPosition={
          lat:latAux,
          lng:lngAux
        }

        console.log(`la latitud es ${latAux} y la longitud es ${lngAux}`)
        // console.log(this.cGetLocation)
        this.cGetLocation[0].setMap(null);
        const { Marker } = this.google.maps;
        let latlng = new google.maps.LatLng(latAux, lngAux);

        let marker=new Marker({
          position: latLng,
          map: this.map,
          draggable:true,
          title: 'Nueva Ubicacion'
        });
        // aca registramos el marker de google
        this.$store.dispatch('sGoogleMaps/addNewPosition', marker);
        // aca registramos la latitud y longitud
        this.$store.dispatch('sGoogleMaps/addNewPositionLocation', auxNewPosition);
      }
    },
    computed:{
      cGetLocation(){
        // return this.$store.getters.getLocation;
        // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
        return this.$store.getters['sGoogleMaps/getLocation'];
      }
    },
    render() {}
  };
</script>


// WEBPACK FOOTER //
// src/components/maps/NewMarkMap.vue